import { api } from "./api";

export const loginApi = (params) => {
    return api.post(`/auth/login`, JSON.stringify(params));
};

export const registerApi = (params) => {
    return api.post(`/auth/sign-up`, JSON.stringify(params));
};

export const fetchAccountApi = (params) => {
    return api.get(`/auth/account`, { params });
};

export const updateAccountApi = (params) => {
    return api.post(`/auth/update-account`, JSON.stringify(params));
};

export const uploadImageApi = (params) => {
    return api.post(`/auth/upload-image`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const forgotPasswordApi = (params) => {
    return api.post(`/auth/forgot-password`, JSON.stringify(params));
};

export const resetPasswordApi = (params) => {
    return api.post(`/auth/reset-password`, JSON.stringify(params));
};